import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/utils/styling';
import { capitalize } from '@/shared/utils';

interface AccountPendingItemProps {
  accountTypeName?: string;
  accountNumber: string;
  className?: string;
}

const AccountPendingItem = ({
  accountTypeName,
  accountNumber,
  className,
}: AccountPendingItemProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex items-center gap-[1.6rem] py-[1.2rem] px-0 md:px-[1.6rem]',
        className
      )}>
      <div className="grow space-y-[0.8rem]">
        <div className="headline4">
          {accountTypeName ? capitalize(accountTypeName) : ''}{' '}
          <span
            className={cn(
              'text-secondary',
              !accountTypeName && 'text-primary'
            )}>
            {accountNumber}
          </span>
        </div>
        <div className="p5 text-secondary dots-animation">
          {t('openAccount.pending')}
        </div>
      </div>
    </div>
  );
};

export { AccountPendingItem };
